import React, { Component } from 'react';
import { DraggableWindow } from './../DraggableWindow';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import { LayersList } from './LayersList/LayersList';
import ApiLayersMap from '../../../../modules/WebApiModules/ApiLayersMap';
import { Divider } from './../../../.common/Divider/Divider';

import ls from 'localstorage-slim';
import reviewLayers from '../LayersMap/LayerReview';

import './LayersMap.css'
export class LayersMap extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            layers: [
                //{
                //    FolderFullName: "",
                //    IsFolder: true,
                //    Name: "底圖",
                //    Layers: [{ FolderFullName: "\/底圖", Name: "正射影像"},{ FolderFullName: "\/底圖", Name: "電子地圖", Class: "OVERLAY", IsDefault: true}]
                //},
                //{
                //    FolderFullName: "",
                //    IsFolder: true,
                //    Name: "三維圖資",
                //    Layers: [{ FolderFullName: "\/三維圖資", Name: "管線"},{ FolderFullName: "\/三維圖資", Class: "FOLDER", Name: "傾斜攝影集", Layers: [{ FolderFullName: "\/三維圖資\/傾斜攝影集", Name: "傾斜攝影", Class: "PHOTOGRAMMETRY"}]}]
                //}
            ]
        }
        this.addedLayers = [];
        this.updateLayerList = {
            addedLayers: this.addedLayers,
            addLayerToList: (layerInfo) => {
                this.handleAddingClick(layerInfo);
            },
            removeLayerFromList: (layerInfo) => {
                const { selectedLayerContext } = this.context;
                for (let i = 0; i < selectedLayerContext.layers.length; i++) {
                    let addedLayer = selectedLayerContext.layers[i];
                    if (addedLayer.Name === layerInfo.Name) {
                        this.handleRemoveClick(layerInfo.Name);
                    }
                }
            }
        }
    }

    componentDidMount() {
        let lsInfo = ls.get("userInfo", { decrypt: true });
        ApiLayersMap.ListAll(
            // success
            async (result) => {
                if (result.success) {
                    if (!lsInfo) {
                        reviewLayers['2DLayer'].forEach((item) => {
                            this.removeLayerFromResult(result.result, item);
                        });

                        reviewLayers['3DLayer'].forEach((item) => {
                            this.removeLayerFromResult(result.result, item);
                        });

                        this.removeEmptyFolder(result.result);
                        this.setState({
                            layers: result.result
                        })
                    }
                    else {
                        let url2DAuthLayer = "https://ntmap.nantou.gov.tw/server/layer/get2DLayerList";
                        let url3DAuthLayer = "https://ntmap.nantou.gov.tw/server/layer/get3DLayerList";

                        await this.reviewLayerWithAuth(reviewLayers['2DLayer'], url2DAuthLayer, result.result);
                        await this.reviewLayerWithAuth(reviewLayers['3DLayer'], url3DAuthLayer, result.result);
                    }
                    this.setState({
                        layers: result.result
                    })
                } else {
                    console.error(`取的圖層清單失敗，${result.error}`);
                }
            },
            // error
            () => {
                console.error("取的圖層清單失敗");
            })
    }

    async reviewLayerWithAuth(reviewLayerList, url, list) {
        let rtn = await new Promise(rs => {
            fetch(url, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
            }).then((response) => {
                return response.json();
            }).then(function (json) {
                if (json.success) {

                    reviewLayerList.forEach((item) => {
                        let condition = (element) => item.ID === element.layername;
                        if (!json.ret.some(condition)) {
                            this.removeLayerFromResult(list, item);
                        }
                    });
                    this.removeEmptyFolder(list);
                    rs(true)
                }
                else {
                    rs(false);
                }
            }.bind(this)).catch((error) => {
                console.log(`Error: ${error}`);
                rs(false);
            })
        });

        return await rtn;
    }

    removeLayerFromResult(list, removeItem) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].Class === "FOLDER") {
                if (this.removeLayerFromResult(list[i].Layers, removeItem)) {
                    return true;
                }
            }
            else {
                if (list[i].ID === removeItem.ID) {
                    list.splice(i, 1);
                    return true;
                }
            }
        }

        return false;
    }

    removeEmptyFolder(list) {
        list.forEach(listItem => {
            if (listItem.Class === "FOLDER") {
                if (listItem.Layers.length === 0) {
                    list.splice(list.indexOf(listItem), 1);
                }
                else {
                    this.removeEmptyFolder(listItem.Layers);
                }
            }
        });
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="圖資庫"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel}
                isShow={this.props.isShow} />
        );
    }

    content() {
        return (
            <div className='layersMap'>
                <div className='LayserListContainer'>
                    <LayersList data={this.state.layers} updateLayerList={this.updateLayerList} />
                </div>
                <Divider />
                {/*<div className='layersMap_addButton' onClick={this.handleAddingClick.bind(this)}>加入</div>*/}
            </div>
        );
    }

    handleAddingClick = (layerInfo) => {
        const { selectedLayerContext } = this.context;
        selectedLayerContext.updateLayers({
            add: [layerInfo]
        });
    }

    handleRemoveClick = (layerName) => {
        const { selectedLayerContext } = this.context;
        console.log(selectedLayerContext);
        selectedLayerContext.updateLayers({
            remove: [layerName]
        });
    }
}